import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: "http://127.0.0.1:8000/api",
  baseURL: "https://staging.api.gpibapps.my.id/api",
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
